export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/3fadfda14f341399d663fd2ed398d959.svg";